import { RWebShare } from "react-web-share";

const ShareButton = ({ text }: { text: string }) => {
    return (
        <RWebShare
            data={{
                text,
                url: `${document.location.origin}/${document.location.pathname}?utm_source=website&utm_medium=share&utm_campaign=copy_link`,
                title: document.location.origin
            }}
            sites={['facebook', 'twitter', 'whatsapp', 'telegram', 'mail', 'copy']}
        >
            <div className="sharediv">
                <i className="fa fa-share-alt-square"></i>
                <span  className="vdp-access-link">
                    Share 
                </span>
            </div>
        </RWebShare>
    );
};

export default ShareButton;
